import { DataTypeOption } from '../FieldsSettings/FieldsSettingsTypes';

interface UpdatedFieldDataParams {
  fieldDataType?: string;
  fieldDataTypeConfig?: DataTypeOption | null;
  glynt_tags?: string[];
  tags?: string[];
  label?: string;
  field_order?: number;
}

export const getUpdatedFieldData = ({
  fieldDataType,
  fieldDataTypeConfig,
  glynt_tags,
  tags,
  label,
  field_order,
}: UpdatedFieldDataParams) => {
  const updatedFieldData: any = {};

  if (glynt_tags) {
    updatedFieldData.glynt_tags = glynt_tags;
  }

  if (tags) {
    updatedFieldData.tags = tags;
  }

  if (label) {
    updatedFieldData.label = label;
  }

  if (field_order) {
    updatedFieldData.field_order = field_order;
  }

  if (fieldDataType) {
    updatedFieldData.data_type = fieldDataType;
    if (fieldDataType === 'number' || fieldDataType === 'amount') {
      const config: { decimalSymbol?: string; thousandsGrouping?: string } = {
        decimalSymbol: fieldDataTypeConfig?.decimalSymbol,
      };
      if (fieldDataTypeConfig?.thousandsGrouping) {
        config.thousandsGrouping = fieldDataTypeConfig.thousandsGrouping;
      }
      updatedFieldData.data_type_config = config;
    } else if (fieldDataType === 'date') {
      updatedFieldData.data_type_config = { order: fieldDataTypeConfig?.order };
    } else {
      updatedFieldData.data_type_config = null;
    }
  }

  return updatedFieldData;
};
